import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const chatwoot = defineConnector({
  identifier: "chatwoot",
  name: "Chatwoot",
  tagLine: "Customer engagement platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://app\\.chatwoot\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "api_access_token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API access token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your Chatwoot instance **Settings > Profile**, and copy your access token.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "Chatwoot host",
          placeholder: "app.chatwoot.com",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Copy and paste the access token into the field below",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/auth/sign_in`,
  },
});
